type MetricFieldProps = {
  label: string;
  value: string;
};

type SliderFieldProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  formatValue?: (v: number) => string;
};

export function MetricField({ label, value }: MetricFieldProps) {
  return (
    <div className="drawer-field">
      <span className="drawer-field-label">{label}</span>
      <span className="drawer-field-value">{value}</span>
    </div>
  );
}

export function SliderField({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  formatValue = (v) => String(v)
}: SliderFieldProps) {
  const range = max - min;
  const fillPercent = range > 0 ? ((value - min) / range) * 100 : 0;
  return (
    <div className="metrics-slider-row">
      <label className="form-label">
        {label}: {formatValue(value)}
      </label>
      <div style={{ "--slider-fill": `${fillPercent}%` } as React.CSSProperties}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          className="metrics-slider"
          onChange={(event) => onChange(Number(event.target.value))}
        />
      </div>
    </div>
  );
}
